import request from '@/utils/request';
// 人工激活SN号
export function manualActivation(options) {
  return request.post('/resource-activation/manual-activation', options);
}

// 获取警告手机号码
export function getResourceActivationPhones() {
  return request.get('/resource-activation/phones');
}
// 修改或添加警告手机号码
export function updateResourceActivationPhone(options) {
  return request.post('/resource-activation/phones', options);
}
// 获取资源类型列表
export function getResourceType() {
  return request.get('/resource-activation/resource');
}
// 激活预警列表
export function getResourceActivationWarning() {
  return request.get('/resource-activation/warning');
}

// 人工激活列表
export function getResourceActivationArtificialList(options) {
  const params = param(options);
  return request.get('/resource-activation/artificial?' + params);
}
// 自动激活列表
export function getResourceActivationAutoList(options) {
  const params = param(options);
  return request.get('/resource-activation/auto?' + params);
}
export function activation(options) {
  return request.post('/resource-activation/' + options);
}
function param(data) {
  let url = '';
  for (const k in data) {
    // eslint-disable-next-line eqeqeq
    const value = data[k] != undefined ? data[k] : '';
    url += `&${k}=${encodeURIComponent(value)}`;
  }
  return url ? url.substring(1) : '';
}
